<template>

  <div>
    <ft-select @input="changeMono($event)" :items="CHOICE_ACTIVE" v-model="liqPayOn" class="pointer">
      <v-chip
          dark
          :color="wsACCENT"
          :style="!liqPayOn ? 'opacity : 0.5' : ''"
          class="px-1 justify-end font-weight-medium pointer"
      >

        <v-icon  class="mr-1" >
          {{  liqPayOn ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}
        </v-icon>

        <h5 class="mx-2">{{ liqPayOn ? $t('Active') : $t('NotActive')   }}</h5>

        <v-icon >mdi-menu-down</v-icon>

      </v-chip>
    </ft-select>

    <wsDialog v-if="displayMono"
              v-model="displayMono"
              :title="$t('WayforpaySettings')"
              @save="linkWayforpay"
              :loading="LOADING"
              :save-text="$t('ConfirmLink')">

      <ws-text-field
          v-model="wayforpay.account"
          label="Merchant Account"
          :placeholder="$t('EnterMerchantAccount')"
          dense
          outlined
          hide-details
      />

      <ws-text-field
          class="mt-5"
          v-model="wayforpay.secret"
          :label="$t('WayForPaySecretKey')"
          :placeholder="$t('EnterWayForPaySecretKey')"
          dense
          outlined
          hide-details
      />

    </wsDialog>

  </div>



</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "wayForPaySettings",
  props : {
    value : {
      type : Boolean,
      default : false
    }
  },
  data() {
    return {
      liqPayOn : false,
      displayMono : false,
      wayforpay : {
        way_for_pay_account   : null,
        way_for_pay_secret : null
      }
    }
  },
  watch: {
    value() {
      if ( this.value !== this.liqPayOn ) {
        this.liqPayOn = this.value
      }
    }
  },
  methods : {
    ...mapActions('wayforpay', [
      'LINK_BUSINESS',
      'UNLINK_BUSINESS'
    ]),

    async changeMono(value) {

      if ( !value ) {
        return this.unlinkWayforpay()
      }

      this.liqPayOn = false
      this.liqPay = {
        public_key   : null,
        private_key  : null,
      }
      this.displayMono = true

    },

    async unlinkWayforpay() {

      if (await this.UNLINK_BUSINESS() ) {
        this.notify(this.$t('WayforpayUnlinked'))
        this.$emit('input',false)
        return
      }
    },
    async linkWayforpay() {

      if (!await this.LINK_BUSINESS(this.wayforpay) ) {
        return this.notify(this.$t('WrongWayforpayData'))
      }

      this.$emit('input',true)
      this.notify( this.$t('WayforpayConnected') )
      this.displayMono = false

    },
  },
  mounted() {
    if ( this.value ) {
      this.liqPayOn = this.value
    }
  }
}
</script>

<style scoped>

</style>